import { observer } from "mobx-react-lite";
import { useCompanyStore } from "../hooks";
import CompanySetupStepOne from "./CompanySetupStepOne";
import CompanySetupStepTwo from "./CompanySetupStepTwo";
import CompanySetupStepThree from "./CompanySetupStepThree";
import CompanySetupStepFour from "./CompanySetupStepFour";
import CompanySetupStepFive from "./CompanySetupStepFive";
import CompanySetupSystemSettings from "./CompanySetupSystemSettings";
import CompanySetupSummary from "./CompanySetupSummary";

const CompanySetupStepContent = observer(
  ({
    showSystemSettings = false,
    showGhgBaseline = false,
    companyNameError,
    companyNameDescription,
    companyNameDescriptionClassName,
  }) => {
    const { step } = useCompanyStore();

    if (step === 1)
      return (
        <CompanySetupStepOne
          companyNameError={companyNameError}
          companyNameDescription={companyNameDescription}
          companyNameDescriptionClassName={companyNameDescriptionClassName}
        />
      );
    if (step === 2) return <CompanySetupStepTwo />;
    if (step === 3) return <CompanySetupStepThree />;
    if (step === 4) return <CompanySetupStepFour />;
    if (step === 5 && showGhgBaseline) return <CompanySetupStepFive />;
    if (step === 6 && showSystemSettings) return <CompanySetupSystemSettings />;
    if (step === (showSystemSettings ? 7 : 6))
      return (
        <CompanySetupSummary
          showSystemSettings={showSystemSettings}
          showGhgBaseline={showGhgBaseline}
          systemSettingsStep={showSystemSettings ? 6 : null}
        />
      );
    return null;
  },
);

export default CompanySetupStepContent;
